import { Schema } from '@core/data/dto/schema';

export const MiscellaneousSchema = {
    amount: Schema.Number,
    annual_limit: Schema.Number,
    percent: Schema.Number,
    total_amount: Schema.Number,
    max_percent: Schema.Number,
    priority: Schema.Number
}
